var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpcomingBigPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0607 1.35355C13.4749 0.767767 12.5251 0.767767 11.9393 1.35355L1.35355 11.9393C0.767767 12.5251 0.767767 13.4749 1.35355 14.0607L11.9393 24.6464C12.5251 25.2322 13.4749 25.2322 14.0607 24.6464L24.6464 14.0607C25.2322 13.4749 25.2322 12.5251 24.6464 11.9393L14.0607 1.35355Z",
    fill: "#6F7985",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingBigPolygon);
export default __webpack_public_path__ + "static/media/upcomingBigPolygon.7f173d18201c6938dc6ae5ce48d45640.svg";
export { ForwardRef as ReactComponent };